import "./_style.css"
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import Paper from '@mui/material/Paper';
import {useParams} from "react-router-dom";
import * as React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Button from "../../components/Button";


export default function ReportItem(props: any) {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)
    const {prjid} = useParams()

    const {reportData} = props

    const [isExpanded, setIsExpanded] = useState<boolean>(false)
    // console.log(isExpanded)

    const [isLoading, setIsLoading] = useState<boolean>(false)
    // console.log(isLoading)

    function sleep(ms:number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    let handleDownload = async () => {
        setIsLoading(true)
        let response = await fetch(`${serverIP}/downloadreport/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid, reportData: reportData}),
        })
        let data = await response.arrayBuffer()

        if (response.status === 200) {
            const blob = new Blob([data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = reportData?.downloadName;   // Specify the desired filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            await sleep(5000)    // 5 sec
            setIsLoading(false)

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }


    return (
        <>
            <div style={{width: '100%'}}>
                <Paper className={isExpanded ? "report-item-header-expanded" : "report-item-header-collapsed"}>

                    <div>{reportData?.title}</div>
                    <div>{reportData?.format}</div>
                    <div>{reportData?.fileSizeKB} KB</div>
                    <div>{reportData?.fileDate}</div>
                    <div>
                        <Button
                            type={isLoading ? "secondary" : "primary"}
                            text="Download"
                            onclick={() => handleDownload()}
                            disabled={isLoading}
                        />
                    </div>
                    <div>
                        {isExpanded ?
                            <ExpandLessIcon
                                className="report-item-expand-button"
                                onClick={() => setIsExpanded(prevIsExp => !prevIsExp)}
                            />
                            :
                            <ExpandMoreIcon
                                className="report-item-expand-button"
                                onClick={() => setIsExpanded(prevIsExp => !prevIsExp)}
                            />
                        }
                    </div>

                </Paper>

                {/*   Description   */}
                {isExpanded &&
                    <Paper className="report-item-description">
                        {reportData?.description}
                    </Paper>
                }

            </div>

        </>
    )
}
